export const FETCH_MAP_DATA = "fetch map data"
export const FETCH_MAP_DATA_SUCCESS = "fetch map data success"
export const FETCH_MAP_DATA_FAILURE = "fetch map data failure"
export const FETCH_VESSEL_DATA_SUCCESS = "fetch port data success"
export const FETCH_VESSEL_DATA_FAILURE = "fetch port data failure"
export const FETCH_ALL_SHIPYARDS_DATA_SUCCESS = "fetch all shipyards data success"
export const FETCH_ALL_SHIPYARDS_DATA_FAILURE = "fetch all shipyards data failure"
export const CHANGE_MAP_ZOOM = "change map zoom"
export const UPDATE_MAP_BOUNDING_BOX = "update map bounding box"
export const UPDATE_MAP_PROPERTY = "update map prpperty"
export const GET_ROUTE = "get route"
export const GET_HEATMAP = "get heat map"
export const REMOVE_ROUTE = "remove route"
export const REMOVE_HEATMAP = "remove heat map"
export const FETCH_NEW_BUILD_SHIPYARDS_DATA = "fetch new build shipyards data"
export const FETCH_NEW_BUILD_SHIPYARDS_DATA_SUCCESS = "fetch new build shipyards data success"
export const FETCH_NEW_BUILD_SHIPYARDS_DATA_FAILURE = "fetch new build shipyards data failure"

export const FETCH_SHIPYARDS_DATA = "fetch shipyards data"
export const FETCH_SHIPYARDS_DATA_SUCCESS = "fetch shipyards data success"
export const FETCH_SHIPYARDS_DATA_FAILURE = "fetch shipyards data failure"
export const FETCH_SHIPYARDS_WATCHLIST_DATA_SUCCESS = "fetch shipyards watchlist data success"
export const FETCH_SHIPYARDS_WATCHLIST_DATA_FAILURE = "fetch shipyards watchlist data failure"
export const FETCH_SHIPYARDS_GEO_DATA = "fetch shipyards geo data"
export const FETCH_SHIPYARDS_GEO_DATA_SUCCESS = "fetch shipyards geo data success"
export const FETCH_SHIPYARDS_GEO_DATA_FAILURE = "fetch shipyards geo data failure"
export const FETCH_ANCHORAGE_GEO_DATA = "fetch anchorage geo data"
export const FETCH_ANCHORAGE_GEO_DATA_SUCCESS = "fetch anchorage geo data success"
export const FETCH_ANCHORAGE_GEO_DATA_FAILURE = "fetch anchorage geo data failure"

export const FETCH_ALL_ANCHORAGE_GEO_DATA = "fetch all anchorage geo data"
export const FETCH_ALL__ANCHORAGE_GEO_DATA_SUCCESS = "fetch all anchorage geo data success"
export const FETCH_ALL__ANCHORAGE_GEO_DATA_FAILURE = "fetch all anchorage geo data failure"
export const FETCH_SEARCH_DATA_SUCCESS = "fetch search data success"
export const FETCH_SEARCH_DATA_FAILURE = "fetch search data failure"

export const FETCH_VESSELS_IN_ANCHORAGE = "fetch vessels in anchorage"
export const FETCH_VESSELS_IN_ANCHORAGE_SUCCESS = "fetch vessels in anchorage success"
export const FETCH_VESSELS_IN_ANCHORAGE_FAILURE = "fetch vessels in anchorage failure"

export const FLY_TO = "fly to"

export const FETCH_VESSEL_TRACKINGS_DATA_SUCCESS = "fetch vessel routes data success"
export const FETCH_VESSEL_TRACKINGS_DATA_FAILURE = "fetch vessel routes data failure"

export const RESET_VESSEL_POSITION = "reset vessel position"
export const RESET_PORT = "reset port"
export const RESET_ALL_SHIPYARDS = "reset all shipyards"

export const fetchMapData = (data) => ({
  type: FETCH_MAP_DATA,
  payload: data
});

export const fetchAnchorageGeoData = (data) => ({
  type: FETCH_ANCHORAGE_GEO_DATA,
  payload: data
});

export const fetchShipyardsData = (data) => ({
  type: FETCH_SHIPYARDS_DATA,
  payload: data
});


export const changeMapZoom = (data) => ({
  type: CHANGE_MAP_ZOOM,
  payload: data
});

export const updateMapBoundingBox = (data) => ({
  type: UPDATE_MAP_BOUNDING_BOX,
  payload: data
});

export const updateMapProperty = (data) => ({
  type: UPDATE_MAP_PROPERTY,
  payload: data
});

export const removeRoute = (data) => ({
  type: REMOVE_ROUTE,
  payload: data
});

export const flyTo = (position) => ({
  type: FLY_TO,
  payload: position
});

export const removeHeatMap = (data) => ({
  type: REMOVE_HEATMAP,
  payload: data
});

export const fetchShipyardsGeoData = (data) => ({
  type: FETCH_SHIPYARDS_GEO_DATA,
  ids: data
});

export const resetVesselPosition = () => ({
  type: RESET_VESSEL_POSITION
});

export const resetPort = () => ({
  type: RESET_PORT
});


export const resetAllShipyards = () => ({
  type: RESET_ALL_SHIPYARDS
});
